export default {
  // filterService4Spu: {},
  // filterArea4Spu: {},
  // serviceCateList: [],
  filterSelf: false,
  businessList: [],
  filterBusiness: {}
}
